import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Frame from '../../../../../../shared/components/Frame';
import Wrapper from '../../../../../../shared/components/Wrapper';
import ReportAnalytical, { ReportSynthetic } from './components/CashinReport';

function Report() {
  const SyntheticContext = useSelector(
    (reducer: IReducer) => reducer.cashInSynthetic
  );

  const analyticContext = useSelector(
    (reducer: IReducer) => reducer.cashInAnalytic
  );

  return (
    <>
      <Frame.Default isActive width="100%" margin="0">
        <Wrapper.Default isActive width="100%">
          {analyticContext.isActive && <ReportAnalytical />}
          {SyntheticContext.isActive && <ReportSynthetic />}
        </Wrapper.Default>
      </Frame.Default>
    </>
  );
}

export default Report;
